/**
 * This file contains willow-api specific constants
 */

/**
 * CONTEXT for willow-api requests
 */
export const CONTEXT: string = "/a/";

/**
 * 'X-Origin' header for all willow-api requests, this header contains original college site host name
 */
export const HEADER_XORIGIN: string = "X-Origin";
